import { AttachFile } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as React from "react";
import { currencyCode, employmentType, Job, salaryUnit } from "../../contents/job/Job";

export const JobItemSmall: React.FC<{job: Job}> = ({ job }) => {
  const wage = `${salaryUnit[job.salary.unit]}${job.salary.min}${currencyCode[job.salary.currencyCode]}以上`
  const type = employmentType[job.employmentType]
  const { t } = useTranslation("jobs");
  const tags = [type, wage, ...job.tags.map(tag => t(tag))];

  return (
    <Link
      to={`/jobs/${job.slug}`}
      aria-disabled={!job.active}
      style={{
        pointerEvents: job.active ? "auto" : "none",
        textDecoration: "none",
        opacity: job.active ? "1" : "0.5"
      }}
    >
      <div className="text-dark h-100 bg-light rounded px-4 py-5 text-start position-relative">
        <AttachFile fontSize="large" className="position-absolute mt-n5 ms-n5" style={{opacity: "0.05", top: "-0.5rem", left: "-0.5rem"}} />
        <div className="text-center mb-4">
          <div className="mb-4">
            <h4 className="mb-0">{t(job.title)}</h4>
            <small>- {t(job.titleEng)} -</small>
          </div>
        </div>
        <div className="mb-4 d-flex justify-content-center flex-wrap">
          {tags.map((i, key) => <small key={key} className="bg-dark text-white px-2 mb-2 mx-1 rounded">{i}</small>)}
        </div>
        <h5 className="text-start"><strong>必須条件</strong></h5>
        <p className="ms-3 mb-4 text-start">{t(job.skill.required)}</p>
        <h5 className="text-start"><strong>歓迎条件</strong></h5>
        <p className="ms-3 mb-4 text-start">{t(job.skill.optional)}</p>
        <div className="text-center mt-5 text-primary">
          <small>詳細を見る &gt;</small>
        </div>
      </div>
    </Link>
  )
}